import React, { memo, useContext, useEffect, useState } from 'react';
import classNames from 'classnames';

import TreeHeader from './treeHeader';
import configCtx from '../services/context.service';
import { LIFECYCLE_HEADER_TITLES } from '@model';
import LeafContainer from './draggableLeafContainer';

function TreeContainer({
  type,
  isLast,
  nodes,
  id,
  stepDes,
  order,
  // toggleShowFirstPhase,
  // isFirstPhaseShow,
  handleAddNode,
  ...rest
}) {
  const {
    collapsedIds,
    changeCollapsedIds,
    activeId,
    idLocations,
    isAllEditing,
    isAllExpanding,
    setActiveId,
    isAllActive,
    changeTreeDataCollection,
    defaultActiveId,
    handleSortEnd,
  } = useContext(configCtx);

  const isExpand = isAllExpanding || !collapsedIds.includes(id);
  const [animationPlaying, toggleAnimationPlaying] = useState(false);
  // const hidePhase = !isFirstPhaseShow && order === 0;

  useEffect(() => {
    let animationEndTimer;
    if (isExpand && !isAllEditing) {
      toggleAnimationPlaying(true);

      animationEndTimer = setTimeout(() => {
        toggleAnimationPlaying(false);
      }, 10);
    } else if (animationPlaying) {
      toggleAnimationPlaying(false);
    }

    return () => {
      clearTimeout(animationEndTimer);
    };
  }, [isExpand]);

  const isActive =
    (defaultActiveId === id && !isAllEditing) || isAllActive || activeId === id;

  // if (hidePhase) {
  //   return (
  //     !isAllEditing && (
  //       <div
  //         className="role-control phase-control-btn phase-show-btn "
  //         onClick={toggleShowFirstPhase}
  //       >
  //         <span className="appkiticon icon-right-chevron-fill a-font-10" />
  //       </div>
  //     )
  //   );
  // }

  const className = classNames('lifecycle-tree-container', `id${id}`, {
    'is-active': isActive,
    'is-animation-playing': animationPlaying,
    'is-animation-ended': !animationPlaying,
    // 'is-hidden': !isFirstPhaseShow && order === 0,
  });

  // const showHidePhaseBtn = order === 0 && !isAllEditing;
  return (
    <div className={className}>
      {/*{showHidePhaseBtn && (*/}
      {/*  <div*/}
      {/*    style={{ display: `${type === 'Divestiture' ? 'none' : 'flex'}` }}*/}
      {/*    className="role-control phase-control-btn phase-hide-btn "*/}
      {/*    onClick={toggleShowFirstPhase}*/}
      {/*  >*/}
      {/*    <span className="appkiticon icon-left-chevron-fill a-font-10" />*/}
      {/*  </div>*/}
      {/*)}*/}
      <TreeHeader
        {...rest}
        id={id}
        type={type}
        onClick={() => {
          console.log('treeContainer:', id);
          setActiveId(id);
        }}
        isLast={isLast}
        stepDes={stepDes}
        title={rest.title || LIFECYCLE_HEADER_TITLES[idLocations.get(id)]}
        onExpand={(e) => {
          e.stopPropagation();
          changeCollapsedIds(id);
        }}
        changeTreeDataCollection={changeTreeDataCollection}
        isExpand={isExpand}
        isAllEditing={isAllEditing}
        isActive={isActive}
        order={order}
      />
      <LeafContainer
        {...rest}
        nodes={nodes}
        isExpand={isExpand}
        onAddNode={() => handleAddNode(id)}
        hasAddNode={isAllEditing}
        containerOrder={idLocations.get(id)?.[0]}
        containerId={id}
        onSortEnd={handleSortEnd}
      />
    </div>
  );
}

TreeContainer.propTypes = {};

export default memo(TreeContainer);
